{
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Vyberte si konverzáciu z ľavého panela",
    "CSAT_REPLY_MESSAGE": "Prosím, ohodnoťte konverzáciu",
    "404": "Sorry, we cannot find the conversation. Please try again",
    "SWITCH_VIEW_LAYOUT": "Switch the layout",
    "DASHBOARD_APP_TAB_MESSAGES": "Messages",
    "UNVERIFIED_SESSION": "Totožnosť tohto používateľa nie je overená",
    "NO_MESSAGE_1": "Zdá sa, že v doručenej pošte nemáte žiadne správy od zákazníkov.",
    "NO_MESSAGE_2": " poslať správu na svoju stránku!",
    "NO_INBOX_1": "Vyzerá to, že ste ešte nepridali žiadnu schránku.",
    "NO_INBOX_2": " na začiatok",
    "NO_INBOX_AGENT": "Zdá sa, že nie ste súčasťou žiadnej schránky. Obráťte sa na svojho správcu",
    "SEARCH_MESSAGES": "Vyhľadávanie správ v konverzáciách",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Prehľadávať správy",
      "RESULT_TITLE": "Search Results",
      "LOADING_MESSAGE": "Crunching data...",
      "PLACEHOLDER": "Napíšte niečo pre vyhľadanie správ",
      "NO_MATCHING_RESULTS": "No results found."
    },
    "UNREAD_MESSAGES": "Unread Messages",
    "UNREAD_MESSAGE": "Unread Message",
    "CLICK_HERE": "Kliknite sem",
    "LOADING_INBOXES": "Načítavajú sa schránky",
    "LOADING_CONVERSATIONS": "Načítavajú sa konverzácie",
    "CANNOT_REPLY": "Neviete odpovedať, pretože",
    "24_HOURS_WINDOW": "24-hodinové obmedzenie okna správ",
    "48_HOURS_WINDOW": "48-hodinové obmedzenie okna správ",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "NOT_ASSIGNED_TO_YOU": "This conversation is not assigned to you. Would you like to assign this conversation to yourself?",
    "ASSIGN_TO_ME": "Prideliť mne",
    "BOT_HANDOFF_MESSAGE": "You are responding to a conversation which is currently handled by an assistant or a bot.",
    "BOT_HANDOFF_ACTION": "Mark open and assign to you",
    "BOT_HANDOFF_REOPEN_ACTION": "Mark conversation open",
    "BOT_HANDOFF_SUCCESS": "Conversation has been handed over to you",
    "BOT_HANDOFF_ERROR": "Failed to take over the conversation. Please try again.",
    "TWILIO_WHATSAPP_CAN_REPLY": "Na túto konverzáciu môžete odpovedať len pomocou šablóny správy z dôvodu",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24-hodinové obmedzenie okna správ",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won’t be able to send messages from this conversation anymore.",
    "INSTAGRAM_RESTRICTION_BANNER": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
    "INSTAGRAM_RESTRICTION_STATUS_LINK": "View status update",
    "REPLYING_TO": "Odpovedáte na:",
    "REMOVE_SELECTION": "Odstrániť výber",
    "DOWNLOAD": "Stiahnuť",
    "UNKNOWN_FILE_TYPE": "Unknown File",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file",
      "MEETING": "{sender} has started a meeting"
    },
    "UPLOADING_ATTACHMENTS": "Prílohy sa nahrávajú...",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "UNSUPPORTED_MESSAGE_TIKTOK": "This message is unsupported. You can view this message on the TikTok app.",
    "UNSUPPORTED_MESSAGE_WHATSAPP": "This message is unsupported. You can view this message on the WhatsApp app.",
    "SUCCESS_DELETE_MESSAGE": "Správa bola úspešne odstránená",
    "FAIL_DELETE_MESSSAGE": "Správu sa nepodarilo vymazať! Skúste to znova",
    "NO_RESPONSE": "Žiadna odpoveď",
    "RESPONSE": "Response",
    "RATING_TITLE": "Hodnotenia",
    "FEEDBACK_TITLE": "Spätná väzba",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Show labels",
      "HIDE_LABELS": "Hide labels",
      "LABELS_COUNT": "{count} labels"
    },
    "VOICE_CALL": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NO_ANSWER": "No answer",
      "NO_ANSWER_OUTBOUND_LABEL": "No answer",
      "NO_ANSWER_OUTBOUND_SUBTEXT": "Contact didn't pick up",
      "MISSED_CALL": "Missed call",
      "MISSED_CALL_INBOUND_SUBTEXT": "No agent picked up",
      "MISSED_CALL_DECLINED_BY": "Declined by {agentName}",
      "CALL_ENDED": "Call ended",
      "HANDLED_BY": "Handled by {agentName}",
      "NOT_ANSWERED_YET": "Not answered yet",
      "CALLING": "Calling…",
      "THEY_ANSWERED": "They answered",
      "YOU_ANSWERED": "You answered",
      "AGENT_ANSWERED": "{agentName} answered",
      "JOIN_CALL": "Join call",
      "CALL_BACK": "Call back",
      "TRANSCRIPT_SHOW_MORE": "Show more",
      "TRANSCRIPT_SHOW_LESS": "Show less"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Vyriešiť",
      "REOPEN_ACTION": "Znovu otvoriť",
      "OPEN_ACTION": "Otvoriť",
      "MORE_ACTIONS": "More actions",
      "OPEN": "Viac",
      "CLOSE": "Zatvoriť",
      "DETAILS": "detaily",
      "COPY_ID_SUCCESS": "Conversation ID copied to clipboard",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "Odložené do zajtra",
      "SNOOZED_UNTIL_NEXT_WEEK": "Odložené do ďalšieho týždňa",
      "SNOOZED_UNTIL_NEXT_REPLY": "Odložené do ďalšej odpovede",
      "WHATSAPP_CALL": "Start WhatsApp call",
      "WHATSAPP_CALL_FAILED": "Could not start the WhatsApp call.",
      "VOICE_CALL": "Start call",
      "VOICE_CALL_FAILED": "Could not start the call.",
      "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
      "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Označiť ako čakajúce na vybavenie",
      "SNOOZE_UNTIL": "Snooze",
      "SNOOZE": {
        "TITLE": "Odložiť do",
        "NEXT_REPLY": "Ďalšia odpoveď",
        "TOMORROW": "Zajtra",
        "NEXT_WEEK": "Ďalší ťýždeň"
      }
    },
    "MENTION": {
      "AGENTS": "Agenti",
      "TEAMS": "Teams"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Odložiť do",
      "APPLY": "Snooze",
      "CANCEL": "Zrušiť"
    },
    "PRIORITY": {
      "TITLE": "Priority",
      "OPTIONS": {
        "NONE": "Žiadne",
        "URGENT": "Urgent",
        "HIGH": "High",
        "MEDIUM": "Medium",
        "LOW": "Low"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Žiadne",
        "INPUT_PLACEHOLDER": "Select priority",
        "NO_RESULTS": "Žiadne výsledky neboli nájdené",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "DELETE_CONVERSATION": {
      "TITLE": "Delete conversation #{conversationId}",
      "DESCRIPTION": "Are you sure you want to delete this conversation?",
      "CONFIRM": "Vymazať"
    },
    "CARD_CONTEXT_MENU": {
      "PENDING": "Označiť ako čakajúce na vybavenie",
      "RESOLVED": "Mark as resolved",
      "MARK_AS_UNREAD": "Mark as unread",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Reopen conversation",
      "SNOOZE": {
        "TITLE": "Snooze",
        "NEXT_REPLY": "Until next reply",
        "TOMORROW": "Until tomorrow",
        "NEXT_WEEK": "Until next week"
      },
      "ASSIGN_AGENT": "Assign agent",
      "ASSIGN_LABEL": "Assign label",
      "AGENTS_LOADING": "Loading agents...",
      "ASSIGN_TEAM": "Assign team",
      "DELETE": "Delete conversation",
      "OPEN_IN_NEW_TAB": "Open in new tab",
      "COPY_LINK": "Copy conversation link",
      "COPY_LINK_SUCCESS": "Conversation link copied to clipboard",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Conversation id {conversationId} assigned to \"{agentName}\"",
          "FAILED": "Couldn't assign agent. Please try again."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Couldn't assign label. Please try again."
        },
        "LABEL_REMOVAL": {
          "SUCCESFUL": "Removed label #{labelName} from conversation id {conversationId}",
          "FAILED": "Couldn't remove label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Assigned team \"{team}\" to conversation id {conversationId}",
          "FAILED": "Couldn't assign team. Please try again."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Message signature",
      "ENABLE_SIGN_TOOLTIP": "Enable signature",
      "DISABLE_SIGN_TOOLTIP": "Disable signature",
      "MSG_INPUT": "Shift + enter pre nový riadok. Ak chcete vybrať Uloženú odpoveď, začnite klávesou '/'.",
      "PRIVATE_MSG_INPUT": "Shift + enter pre nový riadok. Toto bude viditeľné len pre agentov",
      "MESSAGING_RESTRICTED": "You cannot reply to this conversation",
      "MESSAGING_RESTRICTED_WHATSAPP": "You can only reply using a template message due to 24-hour message window restriction",
      "MESSAGING_RESTRICTED_API": "You can only reply using a template message due to message window restriction",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Message signature is not configured, please configure it in profile settings.",
      "COPILOT_MSG_INPUT": "Dajte copilotu ďalšie podnety alebo sa opýtajte na čokoľvek... Stlačte enter pre odoslanie ďalšej správy",
      "CLICK_HERE": "Click here to update",
      "WHATSAPP_TEMPLATES": "Whatsapp Templates"
    },
    "REPLYBOX": {
      "REPLY": "Odpovedať",
      "PRIVATE_NOTE": "Súkromná správa",
      "SEND": "Poslať",
      "CREATE": "Pridať poznámku",
      "INSERT_READ_MORE": "Read more",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "TIP_EMOJI_ICON": "Zobraz výber emotikonov",
      "TIP_ATTACH_ICON": "Pripojiť súbory",
      "TIP_AUDIORECORDER_ICON": "Record audio",
      "TIP_AUDIORECORDER_PERMISSION": "Allow access to audio",
      "TIP_AUDIORECORDER_ERROR": "Could not open the audio",
      "AUDIO_CONVERSION_FAILED": "Audio conversion failed. Please try again.",
      "DRAG_DROP": "Potiahnite sem na pripojenie",
      "IMAGE_UPLOAD_SUCCESS": "Image uploaded successfully",
      "START_AUDIO_RECORDING": "Start audio recording",
      "STOP_AUDIO_RECORDING": "Stop audio recording",
      "COPILOT_THINKING": "Copilot rozmýšľa",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "Pridať skrytú kópiu",
        "CC": {
          "LABEL": "Kópia",
          "PLACEHOLDER": "E-maily oddelené čiarkami",
          "ERROR": "Zadajte platné e-mailové adresy"
        },
        "BCC": {
          "LABEL": "Skrytá kópia",
          "PLACEHOLDER": "E-maily oddelené čiarkami",
          "ERROR": "Zadajte platné e-mailové adresy"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Poslať",
          "CANCEL": "Zrušiť"
        }
      },
      "QUOTED_REPLY": {
        "ENABLE_TOOLTIP": "Include quoted email thread",
        "DISABLE_TOOLTIP": "Don't include quoted email thread",
        "REMOVE_PREVIEW": "Remove quoted email thread",
        "COLLAPSE": "Collapse preview",
        "EXPAND": "Expand preview"
      }
    },
    "VISIBLE_TO_AGENTS": "Private Note: Only visible to you and your team",
    "CHANGE_STATUS": "Conversation status changed",
    "CHANGE_STATUS_FAILED": "Conversation status change failed",
    "CHANGE_AGENT": "Conversation Assignee changed",
    "CHANGE_AGENT_FAILED": "Assignee change failed",
    "ASSIGN_LABEL_SUCCESFUL": "Label assigned successfully",
    "ASSIGN_LABEL_FAILED": "Label assignment failed",
    "CHANGE_TEAM": "Conversation team changed",
    "SUCCESS_DELETE_CONVERSATION": "Conversation deleted successfully",
    "FAIL_DELETE_CONVERSATION": "Couldn't delete conversation! Try again",
    "FILE_SIZE_LIMIT": "File exceeds the {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB attachment limit",
    "FILE_TYPE_NOT_SUPPORTED": "This {fileName} file type is not supported in this conversation",
    "MESSAGE_ERROR": "Unable to send this message, please try again later",
    "SENT_BY": "Sent by:",
    "BOT": "Bot",
    "NATIVE_APP": "Native app",
    "NATIVE_APP_ADVISORY": "This message was sent from the native app. Reply from Chatwoot to maintain the message window.",
    "SEND_FAILED": "Couldn't send message! Try again",
    "TRY_AGAIN": "retry",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Select Agent",
      "REMOVE": "Remove",
      "ASSIGN": "Assign"
    },
    "CONTEXT_MENU": {
      "COPY": "Copy",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Vymazať",
      "CREATE_A_CANNED_RESPONSE": "Add to canned responses",
      "TRANSLATE": "Translate",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Vymazať",
        "CANCEL": "Zrušiť"
      },
      "REPORT_MESSAGE": {
        "LABEL": "Report message",
        "TITLE": "Report Captain message",
        "DESCRIPTION": "Found an issue with this AI response? Let us know what went wrong and our team will review it to help improve Captain's accuracy.",
        "PROBLEM_TYPE": "Problem type",
        "PROBLEM_TYPE_PLACEHOLDER": "Select a problem type",
        "DESCRIPTION_LABEL": "Description",
        "DESCRIPTION_PLACEHOLDER": "Describe the problem in detail",
        "SUBMIT": "Report",
        "SUCCESS": "Thanks for reporting. Our team will take a look.",
        "ERROR": "Could not report this message. Please try again.",
        "REASONS": {
          "incorrect_information": "Incorrect information",
          "inappropriate_response": "Inappropriate response",
          "incomplete_response": "Incomplete response",
          "outdated_information": "Outdated information",
          "other": "Other"
        }
      }
    },
    "SIDEBAR": {
      "CONTACT": "Contact",
      "COPILOT": "Copilot"
    },
    "VOICE_WIDGET": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NOT_ANSWERED_YET": "Not answered yet",
      "HANDLED_IN_ANOTHER_TAB": "Being handled in another tab",
      "REJECT_CALL": "Reject",
      "DISMISS_CALL": "Dismiss",
      "JOIN_CALL": "Join call",
      "END_CALL": "End call",
      "MUTE": "Mute mic",
      "UNMUTE": "Unmute mic",
      "VIEW_CHAT_HISTORY": "View chat history",
      "GO_TO_CONVERSATION": "Go to conversation thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Odoslať prepis konverzácie",
    "DESC": "Odoslať prepis konverzácie na špecifikovanú e-mailovú adresu",
    "SUBMIT": "Odoslať",
    "CANCEL": "Zrušiť",
    "SEND_EMAIL_SUCCESS": "Prepis chatu bol úspešne odoslaný",
    "SEND_EMAIL_ERROR": "Vyskytla sa chyba, skúste to prosím znova",
    "SEND_EMAIL_PAYMENT_REQUIRED": "Email transcript is not available on your current plan. Please upgrade to use this feature.",
    "FORM": {
      "SEND_TO_CONTACT": "Odoslať prepis chatu zákazníkovi",
      "SEND_TO_AGENT": "Odoslať prepis pridelenému agentovi",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Odoslanie prepisu na inú emailovú adresu",
      "EMAIL": {
        "PLACEHOLDER": "Zadať e-mailovú adresu",
        "ERROR": "Prosím zadajte platnú e-mailovú adresu"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Ahoj 👋, vitaj v {installationName}!",
    "DESCRIPTION": "Ďakujeme za registráciu. Chceme, aby ste z {installationName} vyťažili čo najviac. Tu je niekoľko vecí, ktoré môžete urobiť v {installationName}, aby ste si spríjemnili zážitok.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Prečítajte si naše novinky",
    "ALL_CONVERSATION": {
      "TITLE": "Všetky vaše konverzácie na jednom mieste",
      "DESCRIPTION": "Zobrazte si všetky konverzácie od svojich zákazníkov na jednom ovládacom paneli. Konverzácie môžete filtrovať podľa prichádzajúceho kanála, štítku a statusu.",
      "NEW_LINK": "Kliknite sem pre vytvorenie schránky"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Pozvite členov svojho tímu",
      "DESCRIPTION": "Since you are getting ready to talk to your customer, bring in your teammates to assist you. You can invite your teammates by adding their email addresses to the agent list.",
      "NEW_LINK": "Kliknite sem pre pozvanie člena tímu"
    },
    "LABELS": {
      "TITLE": "Usporiadajte si konverzácie pomocou štítkov",
      "DESCRIPTION": "Štítky umožňujú jednoduchšie kategorizovať konverzáciu. Vytvorte si niekoľko štítkov, napríklad #podpora-dotaz, #vyuctovanie-otazka atď., aby ste ich mohli neskôr použiť v konverzácii.",
      "NEW_LINK": "Kliknutím sem vytvoríte tagy"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Pridelený agent",
    "SELF_ASSIGN": "Prideliť mne",
    "TEAM_LABEL": "Pridelený tím",
    "SELECT": {
      "PLACEHOLDER": "Žiadne"
    },
    "ACCORDION": {
      "CONTACT_DETAILS": "Konktaktné detaily",
      "CONVERSATION_ACTIONS": "Akcie konverzácie",
      "CONVERSATION_LABELS": "Označenia konverzácii",
      "CONVERSATION_INFO": "Informácie o konverzácii",
      "CONTACT_NOTES": "Contact Notes",
      "CONTACT_ATTRIBUTES": "Atribúty kontaktu",
      "PREVIOUS_CONVERSATION": "Prechádzajúce konverzácie",
      "MACROS": "Macros",
      "LINEAR_ISSUES": "Linked Linear Issues",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "SHARED_FILES": "Attachments"
    },
    "SHARED_FILES": {
      "EMPTY": "No attachments yet",
      "DOWNLOAD": "Download file",
      "DOWNLOAD_ERROR": "Could not download the file. Please try again.",
      "MEDIA_HEADING": "Media",
      "FILES_HEADING": "Files",
      "VIEW_ALL": "View all",
      "SHOW_LESS": "Show less",
      "MORE_COUNT": "+{count}",
      "UNTITLED_FILE": "Untitled file",
      "JUMP_TO_MESSAGE": "Jump to message"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Čaká sa na",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Vytvoriť atribút",
    "NO_RECORDS_FOUND": "Žiadne atribúty neboli nájdené",
    "UPDATE": {
      "SUCCESS": "Atribút úspešne nahraný",
      "ERROR": "Nie je možné aktualizovať atribút. Skúste to prosím neskôr"
    },
    "ADD": {
      "TITLE": "Pridať",
      "SUCCESS": "Nový atribút úspešne pridaný",
      "ERROR": "Nebolo možné pridať atribút. Skúste to prosím neskôr"
    },
    "DELETE": {
      "SUCCESS": "Aitribút úspešne vymazaný",
      "ERROR": "Nie je možné odstrániť atribút. Skúste to prosím neskôr"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Pridať atribúty",
      "PLACEHOLDER": "Hľadať atribúty",
      "NO_RESULT": "Žiadne atribúty neboli nájdené"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "From",
    "TO": "Pre",
    "BCC": "Skrytá kópia",
    "CC": "Kópia",
    "SUBJECT": "Predmet",
    "EXPAND": "Expand email"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "Žiadne výsledky neboli nájdené",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    }
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  }
}
